import { v4 as uuidv4 } from "uuid";
//videos
import video1 from "../src/videos/video1.mp4";
import video2 from "../src/videos/video2.mp4";
import video3 from "../src/videos/video3.mp4";
import video4 from "../src/videos/video4.mp4";
import video5 from "../src/videos/video5.mp4";

export const chillHop = [
  {
    album: "Late Night Essentials",
    name: "Night Owl",
    cover: "https://i.scdn.co/image/ab67616d0000b27344c53b2c3a1457e1498ce55e",
    artist: "brillion.",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=35641",
    color: ["#3A2ED0", "#ECCCFD"],
    id: uuidv4(),
    active: true,
    writer: "cocabona",
    producer: "oddfish",
    mixer: "Strehlow",
  },
  {
    album: "Late Night Essentials",
    name: "Growing Through The Cracks",
    cover: "https://i.scdn.co/image/ab67616d0000b273cf6542bf8361937ca6e24800",
    artist: " Philanthrope, mommy ",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=35636",
    color: ["#3A2ED0", "#ECCCFD"],
    id: uuidv4(),
    active: false,
    writer: "cocabona",
    producer: "oddfish",
    mixer: "Strehlow",
  },
  {
    album: "Late Night Essentials",
    name: "End of Youth",
    cover: "https://i.scdn.co/image/ab67616d0000b273d4282d8a398d1559d6d03e99",
    artist: "When Mountains Move",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=35657",
    color: ["#3A2ED0", "#ECCCFD"],
    id: uuidv4(),
    active: false,
    writer: "cocabona",
    producer: "oddfish",
    mixer: "Strehlow",
  },
  {
    album: "Late Night Essentials",
    name: "Rainbow Roll",
    cover: "https://i.scdn.co/image/ab67616d0000b27334d70ae4de5f638886d3a3ff",
    artist: "Strehlow",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=35642",
    color: ["#3A2ED0", "#ECCCFD"],
    id: uuidv4(),
    active: false,
    writer: "cocabona",
    producer: "oddfish",
    mixer: "Strehlow",
  },
  {
    album: "Late Night Essentials",
    name: "Roaming",
    cover: "https://i.scdn.co/image/ab67616d0000b273332e23e617f4e40773affcb5",
    artist: "L'Indécis",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=35662",
    color: ["#3A2ED0", "#ECCCFD"],
    id: uuidv4(),
    active: false,
    writer: "cocabona",
    producer: "oddfish",
    mixer: "Strehlow",
  },
  {
    album: "Late Night Essentials",
    name: "Minnie",
    cover: "https://i.scdn.co/image/ab67616d0000b2731b8366da3124f10a8363d44f",
    artist: " HM Surf, Mama Aiuto ",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=35660",
    color: ["#3A2ED0", "#ECCCFD"],
    id: uuidv4(),
    active: false,
    writer: "cocabona",
    producer: "oddfish",
    mixer: "Strehlow",
  },
  {
    album: "Late Night Essentials",
    name: "Assembly",
    cover: "https://i.scdn.co/image/ab67616d0000b273d4282d8a398d1559d6d03e99",
    artist: " Dotlights, Almøst Silent ",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=35663",
    color: ["#3A2ED0", "#ECCCFD"],
    id: uuidv4(),
    active: false,
    writer: "fantompower",
    producer: "the Dark",
    mixer: "David Perlick-Molinari",
  },
  {
    album: "Late Night Essentials",
    name: "Ripple Effect",
    cover: "https://i.scdn.co/image/ab67616d0000b273a327fe450e20e2d3e6c4ac6f",
    artist: "Knowmadic",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=35640",
    color: ["#3A2ED0", "#ECCCFD"],
    id: uuidv4(),
    active: false,
    writer: "fantompower",
    producer: "the Dark",
    mixer: "David Perlick-Molinari",
  },
  {
    name: "Nectarine",
    cover: "https://i.scdn.co/image/ab67616d0000b27309329dd7c798f66c396ac9b5",
    artist: " Es-K, Danny James, John Culbreth ",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=34242",
    color: ["#647843", "#B00100"],
    id: uuidv4(),
    active: false,
    writer: "Knowmadic",
    producer: "Dotlights",
    mixer: "Almøst Silent",
  },
  {
    album: "Chillville",
    name: "Stay Positive",
    cover: "https://i.scdn.co/image/ab67616d0000b2736457a7b89708b6c7441016a7",
    artist: "Aves",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=32859",
    color: ["#45AFD7", "#91817D"],
    id: uuidv4(),
    active: false,
    writer: " HM Surf, Mama Aiuto ",
    producer: "Masked Man",
    mixer: "David Perlick-Molinari",
  },
  {
    album: "Chillville",
    name: "Blessed",
    cover: "https://i.scdn.co/image/ab67616d0000b273e5852cd50201ae82191cc7ba",
    artist: " Moods, Yasper ",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=32860",
    color: ["#45AFD7", "#91817D"],
    id: uuidv4(),
    active: false,
    writer: " HM Surf, Mama Aiuto ",
    producer: "Masked Man",
    mixer: "David Perlick-Molinari",
  },
  {
    album: "Chillville",
    name: "Curosau",
    cover: "https://i.scdn.co/image/ab67616d0000b2733698affed309bbdd00b03aac",
    artist: " Psalm Trees, Chico Balbin ",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=32846",
    color: ["#45AFD7", "#91817D"],
    id: uuidv4(),
    active: false,
    writer: " HM Surf, Mama Aiuto ",
    producer: "Masked Man",
    mixer: "David Perlick-Molinari",
  },
  {
    album: "Chillville",
    name: "Reflections",
    cover: "https://i.scdn.co/image/ab67616d0000b273609989517da2836064d2c051",
    artist: "King I Divine",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=32854",
    color: ["#45AFD7", "#91817D"],
    id: uuidv4(),
    active: false,
    writer: " HM Surf, Mama Aiuto ",
    producer: "Masked Man",
    mixer: "David Perlick-Molinari",
  },
  {
    album: "Chillville",
    name: "Zephyr",
    cover: "https://i.scdn.co/image/ab67616d0000b2739f8f1a4dd4491d4209970a67",
    artist: " Makzo, jacuzzi jefferson, [ocean jams] ",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=32865",
    color: ["#45AFD7", "#91817D"],
    id: uuidv4(),
    active: false,
    writer: "Makzo",
    producer: "jacuzzi jefferson",
    mixer: "[ocean jams]",
  },
  {
    album: "Chillville",
    name: "Dialed Up",
    cover: "https://i.scdn.co/image/ab67616d0000b273b2f5b8cce9d9040b12121032",
    artist: "The Doppelgangaz",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=32883",
    color: ["#45AFD7", "#91817D"],
    id: uuidv4(),
    active: false,
    writer: " The Doppelgangaz ",
    producer: "Masked Man",
    mixer: "David Perlick-Molinari",
  },
  {
    album: "Chillville",
    name: "Jellyfish-Lamp",
    cover: "https://i.scdn.co/image/ab67616d0000b2735b0058ff98d41ec1e178e76e",
    artist: "mommy",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=32850",
    color: ["#45AFD7", "#91817D"],
    id: uuidv4(),
    active: false,
    writer: "Afroham",
    producer: "mommy",
    mixer: "sadtoi",
  },
  {
    name: "Lost In This Moment",
    cover: "https://i.scdn.co/image/ab67616d0000b273276b59678ee7503d434cee3a",
    artist: " Evil Needle, Misha ",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=32855",
    color: ["#45AFD7", "#9E4C34"],
    id: uuidv4(),
    active: false,
    writer: "Misha",
    producer: "ALEXANDER",
    mixer: "Molinari",
  },
  {
    name: "Sundials",
    cover: "https://i.scdn.co/image/ab67616d00001e02cc91dc809c14444da790c0c0",
    artist: " chief., Shrimpnose ",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=41687",
    color: ["#E3ACB9", "#636466"],
    id: uuidv4(),
    active: false,
    writer: "Shrimpnose, chief.",
    producer: "chief.",
    mixer: "David",
  },
  {
    name: "A Reminder",
    cover: "https://i.scdn.co/image/ab67616d00001e02da7b66623b34bf5dcff5db38",
    artist: " Sleepy Fish, coa ",
    audio: "https://mp3.chillhop.com/serve.php/?mp3=36925",
    color: ["#EFB86E", "#B10101"],
    id: uuidv4(),
    active: false,
    writer: "Philanthrope",
    producer: "Sleepy Fish",
    mixer: "A Reminder",
  },
];

export const vidHop = [
  {
    name: "Distant Dreaming",
    cover: "https://i.scdn.co/image/ab67616d0000b273e5852cd50201ae82191cc7ba",
    artist: "Burn Water",
    writer: " Mama Aiuto ",
    producer: "Masked Man",
    mixer: "Molinari",
    what: 'In collaboration with The Knocks, we worked with Blu on her debut singles "In My Head" and "Mad Love" providing mixes, additional production, and vocal record. Since those sessions she has emerged as a break-through artist amassing over 1M followers on TikTok, 50M streams on Spotify alone, and touring sold-out performances across the country.',
    id: uuidv4(),
    url: video1,
  },
  {
    name: "The Truth",
    cover: "https://i.scdn.co/image/ab67616d0000b2736457a7b89708b6c7441016a7",
    artist: "Burn Water",
    writer: " HM Surf, Mama Aiuto ",
    producer: "Masked Man",
    mixer: "David Perlick-Molinari",
    what: "Our very own Pink Flamingo Rhythm Revue's collaboration with Purple Disco Machine 'Money Money' was released as the lead track of the European powerhouse's sophomore album, Exotica. ",
    id: uuidv4(),
    url: video2,
  },
  {
    name: "Fate",
    cover: "https://i.scdn.co/image/ab67616d0000b273b2f5b8cce9d9040b12121032",
    artist: "Burn Water",
    writer: " The Doppelgangaz ",
    producer: "Masked Man",
    mixer: "David",
    what: "Seamlessly blending her love of 60s-era pop, rock, and standards with current electronic production, her fun and soulful tracks dance that magical line between feeling utterly classic and totally fresh. After years as a side project, 2019 sees Deidre & the Dark strut to the foreground with the debut album Variety Hour - a record of “nostalgic noir-pop enhanced by modern stereophonics” (Culture Collide), featuring recent singles “Bad Day,” “Back In Time” and “One Night” - “...a bold and brassy declaration of love for the 60s girl groups, 70s Philly soul, and modern R&B that delivers the kinds of hooks and euphoria found only in the very best pop records.” (WFMU, Sheila B)",
    id: uuidv4(),
    url: video3,
  },
  {
    name: "Ikigai",
    cover: "https://i.scdn.co/image/ab67616d0000b273276b59678ee7503d434cee3a",
    artist: "Burn Water",
    writer: "Misha",
    producer: "ALEXANDER",
    mixer: "Molinari",
    what: "Today, we have a new joint effort from the smoldering Violet Sands and nu-disco producer Justin Faust that carries that particular flame channeled through a slightly more modern prism. 'What Do You Feel' finds Faust wading in more down-tempo waters as he explores the brilliant aural canvas that is the enveloping aesthetic of Violet Sands. The result is a layered, mysterious, dark yet shimmering track perfect for the opening or closing credits of any show or movie.",
    id: uuidv4(),
    url: video4,
  },
  {
    name: "A Promise",
    cover:
      "https://chillhop.com/wp-content/uploads/2022/07/4f05da370f675eb78a6b92880f93c4e7787935e3-1024x1024.jpg",
    artist: "Burn Water",
    writer: "Shrimpnose, chief.",
    producer: "chief.",
    mixer: "David",
    what: "YouTooCanWoo in-house artist French Horn Rebellion was selected to remix Beyoncé's single 7/11 from her seminal self-titled album.",
    id: uuidv4(),
    url: video5,
  },
];

export const imageHop = [
  { link: "row-1-column-1.png", id: uuidv4() },
  { link: "row-1-column-1(1).png", id: uuidv4() },
  { link: "row-1-column-1(2).png", id: uuidv4() },
  { link: "row-1-column-1(3).png", id: uuidv4() },
  { link: "row-1-column-1(4).png", id: uuidv4() },
  { link: "row-1-column-1(5).png", id: uuidv4() },
  { link: "row-1-column-2.png", id: uuidv4() },
  { link: "row-1-column-2(1).png", id: uuidv4() },
  { link: "row-1-column-2(2).png", id: uuidv4() },
  { link: "row-1-column-2(3).png", id: uuidv4() },
  { link: "row-1-column-2(4).png", id: uuidv4() },
  { link: "row-1-column-2(5).png", id: uuidv4() },
  { link: "row-1-column-3.png", id: uuidv4() },
  { link: "row-1-column-3(2).png", id: uuidv4() },
  { link: "row-1-column-3(3).png", id: uuidv4() },
  { link: "row-1-column-3(4).png", id: uuidv4() },
  { link: "row-1-column-3(5).png", id: uuidv4() },
  { link: "row-1-column-4.png", id: uuidv4() },
  { link: "row-2-column-1.png", id: uuidv4() },
  { link: "row-2-column-1(1).png", id: uuidv4() },
  { link: "row-2-column-1(2).png", id: uuidv4() },
  { link: "row-2-column-1(3).png", id: uuidv4() },
];
